<template>
  <!--
      [ 간격 옵션 : spacing--sm ]
      spacing--sm
      spacing--md
      spacing--lg

      [ 보더 옵션 : 없음 ]
      .style--border

      [ 포지션 옵션 : 없음 ]
      .style--floating
      .style--fixed 
  -->

  <header
    class="header-horizontal-type-g OPTION bbb"
    :class="headerClass"
  >
    <div class="header__container--left">
      <form-button
        class="icon--btn btn--lg icon--md"
        icon="dehaze"
        type="button"
        @click="toggleOn"
      ></form-button>
    </div>

    <div class="header__logo-container">
      <logo class=""></logo>
    </div>

    <!-- <div class="header__container--right">
      <form-button
        class="icon--btn btn--lg icon--md"
        icon="work_outline"
      ></form-button>
    </div> -->

    <modal-menu
      v-if="!!isSelected"
      @close="toggleOff"
    ></modal-menu>
  </header>
</template>

<script>
import toggle from '@/component/js/toggle'
import theme from '@/component/js/theme'

export default {
  mixins: [toggle, theme],
  computed: {
    headerClass () {
      return `${this.$route.name === 'home' ? this.themeClasses('homeHeader') : this.themeClasses('header')}`
    }
  },
  components: {
    Logo: () => import('@/component/common/Logo'),
    FormButton: () => import('@/component/ui2/button/FormButton'),
    ModalMenu: () => import('@/component/layout/header/modal/ModalMenu')
  }
}
</script>
